// Get vendor retail bookings
export const GET_VENDOR_RETAIL_BOOKINGS = 'GET_VENDOR_RETAIL_BOOKINGS';
export const GET_VENDOR_RETAIL_BOOKINGS_SUCCESS = 'GET_VENDOR_RETAIL_BOOKINGS_SUCCESS';
export const GET_VENDOR_RETAIL_BOOKINGS_FAILED = 'GET_VENDOR_RETAIL_BOOKINGS_FAILED';

// Get vendor unpaid retail bookings (for payments page)
export const GET_VENDOR_UNPAID_RETAIL_BOOKINGS = 'GET_VENDOR_UNPAID_RETAIL_BOOKINGS';
export const GET_VENDOR_UNPAID_RETAIL_BOOKINGS_SUCCESS =
  'GET_VENDOR_UNPAID_RETAIL_BOOKINGS_SUCCESS';
export const GET_VENDOR_UNPAID_RETAIL_BOOKINGS_FAILED = 'GET_VENDOR_UNPAID_RETAIL_BOOKINGS_FAILED';

// Get vendor paid retail bookings (for payments page - Paid tab)
export const GET_VENDOR_PAID_RETAIL_BOOKINGS = 'GET_VENDOR_PAID_RETAIL_BOOKINGS';
export const GET_VENDOR_PAID_RETAIL_BOOKINGS_SUCCESS = 'GET_VENDOR_PAID_RETAIL_BOOKINGS_SUCCESS';
export const GET_VENDOR_PAID_RETAIL_BOOKINGS_FAILED = 'GET_VENDOR_PAID_RETAIL_BOOKINGS_FAILED';

// Find existing booking
export const FIND_VENDOR_RETAIL_BOOKING = 'FIND_VENDOR_RETAIL_BOOKING';
export const VENDOR_RETAIL_NOT_BOOKED = 'VENDOR_RETAIL_NOT_BOOKED';

// Create/Update booking
export const CREATE_VENDOR_RETAIL_BOOKING = 'CREATE_VENDOR_RETAIL_BOOKING';
export const CREATE_VENDOR_RETAIL_BOOKING_SUCCESS = 'CREATE_VENDOR_RETAIL_BOOKING_SUCCESS';
export const CREATE_VENDOR_RETAIL_BOOKING_FAILED = 'CREATE_VENDOR_RETAIL_BOOKING_FAILED';

// Set booking payload
export const SET_VENDOR_RETAIL_PAYLOAD = 'SET_VENDOR_RETAIL_PAYLOAD';
export const SET_TOTAL_BOOKING_AMOUNT = 'SET_TOTAL_BOOKING_AMOUNT';

// Check availability
export const CHECK_SLOT_AVAILABILITY = 'CHECK_SLOT_AVAILABILITY';
export const CHECK_SLOT_AVAILABILITY_SUCCESS = 'CHECK_SLOT_AVAILABILITY_SUCCESS';
export const CHECK_SLOT_AVAILABILITY_FAILED = 'CHECK_SLOT_AVAILABILITY_FAILED';

// Payment
export const CREATE_RETAIL_CHECKOUT_SESSION = 'CREATE_RETAIL_CHECKOUT_SESSION';
export const CREATE_RETAIL_CHECKOUT_SESSION_SUCCESS = 'CREATE_RETAIL_CHECKOUT_SESSION_SUCCESS';
export const CREATE_RETAIL_CHECKOUT_SESSION_FAILED = 'CREATE_RETAIL_CHECKOUT_SESSION_FAILED';

// Cancel booking
export const CANCEL_RETAIL_BOOKING = 'CANCEL_RETAIL_BOOKING';
export const CANCEL_RETAIL_BOOKING_SUCCESS = 'CANCEL_RETAIL_BOOKING_SUCCESS';
export const CANCEL_RETAIL_BOOKING_FAILED = 'CANCEL_RETAIL_BOOKING_FAILED';

// Reset
export const RESET_VENDOR_RETAIL = 'RESET_VENDOR_RETAIL';

// Venue-side: Get applications
export const GET_VENUE_RETAIL_APPLICATIONS = 'GET_VENUE_RETAIL_APPLICATIONS';
export const GET_VENUE_RETAIL_APPLICATIONS_SUCCESS = 'GET_VENUE_RETAIL_APPLICATIONS_SUCCESS';
export const GET_VENUE_RETAIL_APPLICATIONS_FAILED = 'GET_VENUE_RETAIL_APPLICATIONS_FAILED';

// Venue-side: Update application status
export const UPDATE_RETAIL_APPLICATION_STATUS = 'UPDATE_RETAIL_APPLICATION_STATUS';
export const UPDATE_RETAIL_APPLICATION_STATUS_SUCCESS = 'UPDATE_RETAIL_APPLICATION_STATUS_SUCCESS';
export const UPDATE_RETAIL_APPLICATION_STATUS_FAILED = 'UPDATE_RETAIL_APPLICATION_STATUS_FAILED';

// Venue-side: Cancel booking
export const VENUE_CANCEL_RETAIL_BOOKING = 'VENUE_CANCEL_RETAIL_BOOKING';
export const VENUE_CANCEL_RETAIL_BOOKING_SUCCESS = 'VENUE_CANCEL_RETAIL_BOOKING_SUCCESS';
export const VENUE_CANCEL_RETAIL_BOOKING_FAILED = 'VENUE_CANCEL_RETAIL_BOOKING_FAILED';
